import React, { useCallback, useEffect, useState } from "react";
import { CgBlock, CgCheckO, CgDanger } from "react-icons/cg";
import { FaBook, FaEdit, FaWhatsapp } from "react-icons/fa";
import { FiPrinter } from "react-icons/fi";
import { IoNotifications } from "react-icons/io5";
import { TbRotateClockwise } from "react-icons/tb";
import { ModalLoading } from "../../../components/Loadings/ModalLoading";
import { ModalReservations } from "../../../components/Modals/ModalReservations";
import { ModalReservationsNotifications } from "../../../components/Modals/ModalReservationsNotifications";
import { ModalSendEmail } from "../../../components/Modals/ModalSendEmail";
import { ModalSendWpp } from "../../../components/Modals/ModalSendWpp";
import { PageList, PageListRef } from "../../../components/PageList";
import { ITable } from "../../../components/TableList";
import { useApi } from "../../../hooks/api";
import { useGlobal } from "../../../hooks/global";
import { businessProps, IFilters, IStaysReservationProps } from "../../../interfaces";
import { correctDate, correctDateDashboard, setUpConsultation } from "../../../services/generalServices";
import { info, secondary } from "../../../theme";
import { getCheckStatus, getGuestWithAdicionalGuestsBadge, getOrigin, getStatus } from "../../../utils/columnsTables";
import { getFilterFields } from "../../../utils/filterFields";
import { checkInStatusOptions, get_corrrect_names, reservationStatusOptions } from "../../../utils/options";
import { reservation_status } from "../../../utils/reservation_status";
import { MdDelete, MdOutlineEmail } from "react-icons/md";

export const checkInStatusMapper: { [key: string]: { text: string; color: string, icon: React.ReactElement<any> } } = {
  pending: { text: "Pendente", color: '#FAAD14', icon: <CgDanger size={19} style={{ marginRight: 3 }} /> },
  done: { text: "Realizado", color: '#52C41A', icon: <CgCheckO size={16} style={{ marginRight: 3 }} /> },
  late: { text: "Em atraso", color: '#FF6B6B', icon: <CgBlock size={19} style={{ marginRight: 3 }} /> },
  not_realized: { text: "Não realizado", color: '#FF6B6B', icon: <CgBlock size={16} style={{ marginRight: 3 }} /> },
}

const initialFilters: IFilters[] = [
  getFilterFields("order_by"),
  getFilterFields("reservation_status"),
  getFilterFields("check_in_status"),
  getFilterFields("check_out_status"),
  getFilterFields("check_in"),
  getFilterFields("check_out"),
  getFilterFields("created_at"),
];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "origin",
      name: "Origem",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "stays_id",
      name: "ID",
      style: { textAlign: "center" },
      styleContent: { fontSize: 16, fontWeight: 600, textAlign: "center" },
    },
    {
      attr: "guest_accommodation",
      name: "Hóspede / Acomodação",
      style: {},
      styleContent: { fontSize: 16, display: 'flex', flex: 1 },
    },
    {
      attr: "reservation_status",
      name: "Status da Reserva",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "checkIn",
      name: "Entrada",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "checkOut",
      name: "Saída",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
    {
      attr: "check_in_status",
      name: "Status do Check-in",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "check_out_status",
      name: "Checkout",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14 },
    },
    {
      attr: "createdAt",
      name: "Criado em",
      style: { textAlign: "center" },
      styleContent: { fontSize: 14, textAlign: "center" },
    },
  ],
};

export const propertyInExtension = (address: any) => {
  if (!address) return "-";
  return `${address?.street}, ${address?.region}, Nº ${address?.streetNumber}, ${address?.city} - ${address?.stateCode}`;
};

const getCorrectCreatedAt = (createdAt: any) => {
  const correctCreatedAt = new Date(createdAt)
  correctCreatedAt.setHours(correctCreatedAt.getHours() + 3)
  return correctDate(correctCreatedAt, { no_have_time: true })
}

export const ReservationsListRoot: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify, changeBusinessGlobal } = useGlobal();

  const [businessIdSelected, setBusinessIdSelected] = useState<string | null>(null)

  const [loading, setLoading] = useState(false);
  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [openModalNotification, setOpenModalNotifications] = useState(false);
  const [numOfReservations, setNumOfReservations] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingReservations, setLoadingReservations] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [reservationSelected, setReservationSelected] = useState<IStaysReservationProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);
  const [selectedCheckInSendEmail, setSelectedCheckInSendEmail] = useState<IStaysReservationProps | null>(null);
  const [selectedCheckInSendWpp, setSelectedCheckInSendWpp] = useState<IStaysReservationProps | null>(null);
  const page_ref = React.useRef<PageListRef>(null);

  const selectReservation = useCallback(
    (accomoddation: IStaysReservationProps) => {
      setReservationSelected({ ...accomoddation });
      setOpenModal(true);
    },
    []
  );

  const handleOpenModalNotification = useCallback(
    (accomoddation: IStaysReservationProps) => {
      setReservationSelected({ ...accomoddation });
      setOpenModalNotifications(true);
    },
    []
  );

  const searchReservations = useCallback(
    async (page, _filters = null) => {
      const businessId = localStorage.getItem("@web-checkin:bus_id") || businessIdSelected;

      setAtualPage(page);
      setLoadingReservations(true);
      try {
        const filters_obj = _filters ? _filters : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/root/stays-reservations?page=${page}&limit=${paginationLimit}&bus_id=${businessId}&${string}`;

        const result = await api.get(url);
        const new_reservations = result.data.data as IStaysReservationProps[];
        setTable((atual) => {
          const new_table = { ...atual };

          new_table.data = [];
          new_reservations.forEach((reservation) => {
            const checkInDate = String(reservation.check_in_date).split("T")[0];
            const checkInTime = String(reservation.check_in_time);
            const checkIn = correctDateDashboard(
              new Date(checkInDate + " " + checkInTime)
            );

            const checkOutDate = String(reservation.check_out_date).split(
              "T"
            )[0];
            const checkOutTime = String(reservation.check_out_time);
            const checkOut = correctDateDashboard(
              new Date(checkOutDate + " " + checkOutTime)
            );

            const checkInRealizedDate = String(reservation.correct_realized_check_in)?.split("T")[0];
            const checkInRealizedTime = String(reservation.correct_realized_check_in)?.split("T")[1]?.split(":").slice(0, 2).join(":");
            const checkInRealized = checkInRealizedDate !== 'null' ?
              correctDateDashboard(new Date(checkInRealizedDate + " " + checkInRealizedTime))
              : null;

            const checkOutRealizedDate = String(reservation.correct_realized_check_out)?.split("T")[0];
            const checkOutRealizedTime = String(reservation.correct_realized_check_out)?.split("T")[1]?.split(":").slice(0, 2).join(":");
            const checkOutRealized = checkOutRealizedDate !== 'null' ?
              correctDateDashboard(new Date(checkOutRealizedDate + " " + checkOutRealizedTime))
              : null;

            const guestPrimary = getGuestWithAdicionalGuestsBadge({ guests: reservation?.guests, accommodation_stays_id: reservation?.accommodation_stays_id_code, theme });

            new_table.data.push({
              stays_id: reservation.stays_id,
              id: reservation.id,
              guests: guestPrimary,
              guest_accommodation: guestPrimary,
              reservation_status: getStatus({
                ...reservation_status[reservation.reservation_status],
                theme,
              }),
              check_in_status: getCheckStatus({
                theme,
                dateSrt: checkInRealized,
                ...checkInStatusMapper[reservation.check_in_status],
              }),
              check_out_status: getCheckStatus({
                theme,
                dateSrt: checkOutRealized,
                text: reservation?.check_out?.id ? "Confirmado" : "Não confirmado",
                color: reservation?.check_out?.id ? '#52C41A' : info,
                icon: reservation?.check_out?.id ? <CgCheckO size={16} style={{ marginRight: 3 }} /> : <CgDanger size={16} style={{ marginRight: 3 }} />,
              }),
              checkIn,
              checkOut,
              origin: getOrigin({ origin: reservation.origin, theme }),
              createdAt: getCorrectCreatedAt(reservation.createdAt),
              this: reservation,
            });
          });

          return { ...new_table };
        });
        setNumOfReservations(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelas reservas!", "error");
      }
      setLoadingReservations(false);
    },
    [user, filters, searchString, businessIdSelected]
  );

  const openModalNewReservation = useCallback(() => {
    setReservationSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewReservation();
  };

  const handleRecreateCheckIn = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        await api.post(`/check-ins/create-new-password/${id}`);
        notify("Check-in recriado com sucesso!", "success");
        searchReservations(1);
      } catch (error: any) {
        notify("Erro ao recriar o check-in!", "error");
      }

      setLoading(false);
    },
    [api]
  );

  const handleUpdateReservation = useCallback(async (id: string) => {
    setLoading(true)

    try {
      await api.post(`/stays-reservations/${id}`)
      notify("Reserva atualizada com sucesso!", "success")
      searchReservations(1);
    } catch (err) {
      notify("Erro ao atualizar a reserva!", "error")
    }

    setLoading(false)
  }, []);

  const confirmRecreateCheckIn = useCallback(
    async (item: any): Promise<void> => {
      const result = window.confirm(
        "Tem certeza que deseja recriar o check-in da reserva " +
        item?.stays_id
      );

      if (result) handleRecreateCheckIn(item.check_in_id as unknown as string);
    },
    [handleRecreateCheckIn]
  );

  const handleConfirmDeleteCheckIn = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        await api.delete(`/check-ins/${id}`);

        notify("Check-in excluído com sucesso!", "success");

        await searchReservations(1);
      } catch (error: any) {
        const default_message = "Erro ao excluir a check-in!";
        const message = error.response?.data?.detail ?? default_message;
        notify(message, message === default_message ? "error" : "alert");
      }

      setLoading(false);
    },
    [searchReservations]
  );

  const alertDelete = useCallback(
    async (item: any): Promise<void> => {

      const result = window.confirm(
        "Tem certeza que deseja excluir o check-in da reserva " +
        item?.stays_id
      );

      if (result) handleConfirmDeleteCheckIn(item.check_in_id as unknown as string);
    },
    [handleConfirmDeleteCheckIn]
  );

  const changeBusiness = useCallback((bus_id: string) => {
    changeBusinessGlobal({ id: bus_id } as businessProps)
  }, []);

  const listAction = [
    {
      title: "Editar",
      onClick: (reservation: IStaysReservationProps) => {
        changeBusiness(reservation.bus_id);
        selectReservation(reservation);
      },
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Notificações",
      onClick: (reservation: IStaysReservationProps) => {
        changeBusiness(reservation.bus_id);
        handleOpenModalNotification(reservation);
      },
      icon: <IoNotifications color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Atualizar reserva",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        handleUpdateReservation(item.id);
      },
      icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Enviar email",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        setSelectedCheckInSendEmail(item);
      },
      icon: <MdOutlineEmail color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Enviar WhatsApp",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        setSelectedCheckInSendWpp(item);
      },
      icon: <FaWhatsapp color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Recriar check-in",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        confirmRecreateCheckIn(item);
      },
      icon: <TbRotateClockwise color={secondary[theme]} size={20} />,
      disabled: () => false,
    },
    {
      title: "Excluir check-in",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        alertDelete(item);
      },
      icon: <MdDelete color={secondary[theme]} size={20} />,
      disabled: (item: any) => false,
    },
    {
      title: "Ficha dos hóspedes",
      onClick: (item: any) => {
        changeBusiness(item.bus_id);
        window.open(`/guest-registration-pdf?reservation-id=${item.id}`, "_blank");
      },
      icon: <FiPrinter color={secondary[theme]} size={20} />,
      disabled: () => false,
    }
  ];

  const onSaveReservation = useCallback(() => {
    setOpenModal(false);
    searchReservations(1);
  }, [user, filters, searchString]);

  useEffect(() => {
    const query = window.location.search.split("?").pop()
    const queries = query ? query.split("&") : [""]
    let status: any = queries.find((item: string) => item.split("=")[0] === "status")
    status = status ? status.split("=")[1] : null
    if (status) {
      setFilters({ check_in_status: status, reservation_status: 'booked' })

      page_ref.current?.setFilters((prev) => {
        const checkInStatusFilterIndex = prev.findIndex((filter) => filter.key === "check_in_status" as any)
        const reservationStatusFilterIndex = prev.findIndex((filter) => filter.key === "reservation_status" as any)

        if (checkInStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(checkInStatusOptions);

          prev[checkInStatusFilterIndex] = { ...prev[checkInStatusFilterIndex], value: { label: mapper[status], value: status } }
        }

        if (reservationStatusFilterIndex !== -1) {
          const mapper = get_corrrect_names(reservationStatusOptions);
          prev[reservationStatusFilterIndex] = { ...prev[reservationStatusFilterIndex], value: { label: mapper['booked'], value: 'booked' } }
        }

        return prev
      })

      searchReservations(1, { check_in_status: status, reservation_status: 'booked' })
    }
    else searchReservations(1)
  }, [businessIdSelected]);


  useEffect(() => {
    changeBusiness('null');
  }, []);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingReservations}
      setLoading={setLoadingReservations}
      numberOfItems={numOfReservations}
      onClickOption={handleAction}
      textHeader="Reservas"
      textItems="reservas encontradas"
      text_loading={"Buscando Reservas"}
      text_empty={"Nenhuma reserva encontrada"}
      moduleName="reservations"
      theme={theme}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      pages={numberOfPages}
      page={atualPage}
      search={searchReservations}
      onChangeSearch={setSearchString}
      listActions={listAction}
      setBusinessIdSelected={setBusinessIdSelected}
      ref={page_ref}
    >
      {openModal && (
        <ModalReservations
          onCancel={() => setOpenModal(false)}
          onSave={onSaveReservation}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={reservationSelected?.id}
        />
      )}
      {openModalNotification && (
        <ModalReservationsNotifications
          onCancel={() => setOpenModalNotifications(false)}
          openModal={openModalNotification}
          backgroundVisible={false}
          defaultId={reservationSelected?.id}
        />
      )}
      {loading && <ModalLoading loading={loading} theme={theme} />}
      {selectedCheckInSendWpp?.id && (
        <ModalSendWpp
          onCancel={() => setSelectedCheckInSendWpp(null)}
          onSave={() => setSelectedCheckInSendWpp(null)}
          openModal={!!selectedCheckInSendWpp?.id}
          id={selectedCheckInSendWpp?.id as any}
        />
      )}
      {selectedCheckInSendEmail && (
        <ModalSendEmail
          onCancel={() => setSelectedCheckInSendEmail(null)}
          onSave={() => setSelectedCheckInSendEmail(null)}
          openModal={!!selectedCheckInSendEmail}
          id={selectedCheckInSendEmail.id as any}
        />
      )}
    </PageList>
  );
};
